var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { injectIntl } from "@irati/utils/lang";
import { debounce } from "lodash";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import HR from "@irati/ui/src/Layout/Hr";
import Search from "@irati/ui/src/Search";
import SortBy from "@irati/ui/src/SortBy";
import Flex from "@irati/ui/src/Flex";
import { IconTypes } from "@irati/ui/src/Icon";
import { SORT_OPTIONS } from "../../constants/sort";
import { ALL_PEOPLE, ADMIN, USER, DEACTIVATED_PEOPLE, FILTER_OPTIONS } from "../../constants/filter";
var SortByWithMargin = styled(SortBy)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-right: 10px;\n"], ["\n  margin-right: 10px;\n"])));
var SearchAndSort = /** @class */ (function (_super) {
    __extends(SearchAndSort, _super);
    function SearchAndSort(props) {
        var _this = _super.call(this, props) || this;
        _this.searchRequest = function () {
            var searching = _this.state.searching;
            _this.props.onSearch(searching);
        };
        _this.handleSearch = function (searching) {
            _this.setState({ searching: searching });
            if ((searching === null || searching === void 0 ? void 0 : searching.length) >= 3) {
                _this.searchRequest();
            }
        };
        _this.handleSort = function (_a) {
            var sort = _a.value;
            _this.props.onSort(sort);
        };
        _this.handleFilter = function (_a) {
            var value = _a.value;
            var enabled = !(value === DEACTIVATED_PEOPLE);
            var adminsOnly = !(value === DEACTIVATED_PEOPLE || value === USER);
            if (value === ALL_PEOPLE) {
                enabled = null;
                adminsOnly = false;
            }
            _this.props.onFilter({ enabled: enabled, adminsOnly: adminsOnly });
        };
        _this.getFilterValue = function () {
            var _a = _this.props.variables, enabled = _a.enabled, adminsOnly = _a.adminsOnly;
            if (enabled === false) {
                return DEACTIVATED_PEOPLE;
            }
            if (enabled === null && adminsOnly === false) {
                return ALL_PEOPLE;
            }
            return adminsOnly ? ADMIN : USER;
        };
        _this.state = {
            searching: ""
        };
        _this.searchRequest = debounce(_this.searchRequest.bind(_this), 500);
        return _this;
    }
    SearchAndSort.prototype.render = function () {
        var _a = this.props, sortOptions = _a.sortOptions, filterOptions = _a.filterOptions, variables = _a.variables;
        var searching = this.state.searching;
        return (React.createElement(Row, null,
            React.createElement(Col, { md: 4, sm: 12 },
                React.createElement(Search, { onChange: this.handleSearch, value: searching })),
            React.createElement(Col, { md: 8, sm: 12 },
                React.createElement(Flex, { justifyContent: "flex-end" },
                    sortOptions && variables && variables.sort && (React.createElement(SortByWithMargin, { options: sortOptions, value: variables.sort, onClick: this.handleSort })),
                    filterOptions && (React.createElement(SortBy, { icon: IconTypes.funnel, options: filterOptions, value: this.getFilterValue(), onClick: this.handleFilter })))),
            React.createElement(Col, { xs: 12 },
                React.createElement(HR, { solid: true }))));
    };
    SearchAndSort.defaultProps = {
        sortOptions: SORT_OPTIONS,
        filterOptions: FILTER_OPTIONS
    };
    return SearchAndSort;
}(Component));
export default injectIntl(SearchAndSort);
var templateObject_1;
